import type { FC } from 'react';

import { Icon } from '@pp/core/src/components/icons/icon';
import { Icons } from '@pp/core/src/components/icons/iconNames';
import { IFRAME_TYPE } from '@pp/core/src/store/slices/launcher/types';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import type { LauncherTableInfo } from '../../context/types';

import styles from './Close.module.css';

interface CloseProps {
  close: () => void;
  table: LauncherTableInfo;
}

export const Close: FC<CloseProps> = ({ close, table }: CloseProps) => {
  const mods = useModifiers(
    styles,
    'wrapperbtn',
    {
      lobby: table.iframeType === IFRAME_TYPE.LOBBY,
    },
    { withBaseClass: true }
  );
  return (
    <div className={mods} onClick={close}>
      <span className={styles.wrapperbtn__inner}>
        <Icon icon={Icons.Close} className={styles.closeBtn} />
      </span>
    </div>
  );
};
